export default __webpack_public_path__ + "static/media/bash-compress.72bf0e8a.svg";